<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
}

.history {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182EB;
  line-height: 20px;
  height: 25px;
  cursor: pointer;
  margin-top: 40px;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="flex">
      <div class="title-div">用户信息</div>
      <div class="history" @click="openHistorydig(false)">历史信息</div>
    </div>
    <el-table class="el-table" :data="detailForm.masterList" border max-height="200px"
      style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="pileCode" label="充电桩IMEI编号">
      </el-table-column>
      <el-table-column prop="mobile" label="用户手机号">
      </el-table-column>
      <el-table-column prop="content" label="状态">
        <template><span>已绑定</span></template>
      </el-table-column>
      <el-table-column prop="createdWhen" label="绑定时间">
      </el-table-column>
    </el-table>
    <div class="flex">
      <div class="title-div">亲友信息</div>
      <!-- 安心包设备：AXB 表格已含全部记录(含历史)，故隐藏 PileCust 的"历史信息"入口 -->
      <div v-if="!isAxb" class="history" @click="openHistorydig(true)">历史信息</div>
    </div>
    <!-- 安心包(AXB 598)设备：亲友共享记录 -->
    <el-table v-if="isAxb" class="el-table" :data="detailForm.axbFamilyList" border max-height="200px"
      style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="friendPhone" label="亲友手机号"></el-table-column>
      <el-table-column prop="friendNickname" label="亲友昵称"></el-table-column>
      <el-table-column prop="friendType" label="角色">
        <template slot-scope="scope"><span>{{ typeText(scope.row.friendType) }}</span></template>
      </el-table-column>
      <el-table-column prop="friendPermission" label="权限">
        <template slot-scope="scope"><span>{{ permissionText(scope.row.friendPermission) }}</span></template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope"><span>{{ statusText(scope.row.status) }}</span></template>
      </el-table-column>
      <el-table-column prop="inviteTime" label="邀请时间"></el-table-column>
      <el-table-column prop="friendHandleTime" label="处理时间"></el-table-column>
    </el-table>
    <!-- 安心包设备亲友共享记录分页 -->
    <div class="list-pagination" v-if="isAxb">
      <ZD-pagination :pagination="pagination" v-on:pageUpdate="getAxbFamilyList"></ZD-pagination>
    </div>
    <!-- 非安心包设备：既有 PileCust 亲友 -->
    <el-table v-else class="el-table" :data="detailForm.relList" border max-height="200px" style="width: 100%;margin:20px auto"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="pileCode" label="充电桩IMEI编号">
      </el-table-column>
      <el-table-column prop="mobile" label="用户手机号">
      </el-table-column>
      <el-table-column prop="custType" label="亲友类型">
      </el-table-column>
      <el-table-column prop="content" label="状态">
        <template><span>已添加</span></template>
      </el-table-column>
      <el-table-column prop="createdWhen" label="添加时间">
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="historyDialogVisible">
      <div class="phone">
        <el-table class="el-table" :data="detailForm.relHistoryList" border max-height="200px"
          style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
          <el-table-column prop="pileCode" label="充电桩IMEI编号">
          </el-table-column>
          <el-table-column prop="mobile" label="用户手机号">
          </el-table-column>
          <el-table-column v-if="flag" prop="custType" label="亲友类型">
          </el-table-column>
          <el-table-column prop="content" label="状态">
            <template><span>已解绑</span></template>
          </el-table-column>
          <el-table-column prop="lastModifiedWhen" label="解绑时间">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      chargeData: [],
      selections: [], // 表格选项
      pagination: pageConfig.detailPagination,
      editFlag: false,
      pageTitle: '客户详情',
      // 默认值设置
      detailForm: {
        relList: [],
        masterList: [],
        relHistoryList: [],
        axbFamilyList: [],
      },
      isAxb: false, // 当前桩是否安心包(AXB 598)设备，决定"亲友信息"数据源
      flag: false,
      custInfo: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
      dialogForm: {
        //度电设置弹窗内容
        remark: '',
        chargeValue: '',
      },
      activeName: 'first', //默认激活状态
      operates: {
        width: 220,
        fixed: 'right',
        list: [
          {
            id: 'remark',
            label: '备注',
            type: 'primary',
            show: true,
            disabled: false,
            method: (index, row) => {
              this.openRemark(row)
            },
          },
        ],
      }, // 列操作按钮

      caroperates: {
        width: 220,
        fixed: 'right',
        list: []
      },
      historyDialogVisible: false, //未使用(已删除功能)
      thirdDialogFormVisible: false, //度电设置弹窗
      dialogTitle: '', //未使用(已删除功能)
      dialogLabel: '', //未使用(已删除功能)
      actInExpAmount: '', //未使用(已删除功能)
      recentInTime: '暂无充值记录', //未使用(已删除功能)
      totalChargeValue: '', //累计度电
      chargeBalanceValue: '', //剩余度电
      tipFlag: false, //度电设置弹窗错误提示语
      btnUse: false, //判断是否可以点击确定按钮
      remarkShow: true, //客户备注内容是否显示
      inputShow: false, //备注内容输入框
      btnShow: true, //备注内容编辑按钮
      editShow: false, //备注内容保存按钮
      remarkDialogFormVisible: false, //备注信息弹窗
      dialogRemarkForm: {
        //备注信息表单内容
        remark: '',
      },
      mobileLength: '', //手机号码位数

      // 车辆信息数据
      carInfoTable: [],
      carPagination: pageConfig.carPagination
    }
  },
  methods: {
    init() {
      if (this.$store.state.pileObj) {
        this.pileCode = this.$store.state.pileObj.pileCode
        this.getFormInfo()
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.detailForm.masterList = []
      _.detailForm.relList = []
      _.detailForm.axbFamilyList = []
      // 桩主信息始终来自 PileCust(custType=桩主)；PileCust 亲友仅在非安心包设备时展示
      _.$H.post(_, _.$A.pile.listPileCust, { pileCode: _.pileCode, }).then((res) => {
        (res.data.data || []).forEach(item => {
          if (item.custType == '桩主') {
            _.detailForm.masterList.push(item)
          } else {
            _.detailForm.relList.push(item)
          }
        })
      })
      // 判断是否安心包(AXB 598)设备，决定"亲友信息"数据源
      _.$H.post(_, _.$A.familyShare.isAxbDevice, { pileCode: _.pileCode, }).then((res) => {
        _.isAxb = res.data.data === true
        if (_.isAxb) {
          // 安心包设备：亲友信息取 AXB 598 亲友共享记录(分页、全部状态)
          _.getAxbFamilyList(_.pagination, true)
        }
      })
    },
    // 安心包设备亲友共享记录分页查询(按 pileCode、全部状态)
    getAxbFamilyList(pagination, reload = false) {
      let _ = this
      if (reload) {
        _.pagination.current = 1
      }
      _.pagination.pageSize = pagination.pageSize
      _.$H.post(_, _.$A.familyShare.page, {
        pileCode: _.pileCode,
        pageNum: _.pagination.current - 1, // 后端 pageNum 从 0 开始
        pageSize: _.pagination.pageSize,
      }).then((r) => {
        _.detailForm.axbFamilyList = (r.data.data && r.data.data.content) || []
        _.pagination.total = (r.data.data && r.data.data.totalElements) || 0
      })
    },
    // 获取表单信息
    openHistorydig(flag) {
      let _ = this
      _.$H.post(_, _.$A.pile.listHirtoryRelation, { pileCode: _.pileCode, custType: flag ? '亲友' : '桩主' }).then((res) => {
        this.flag = flag
        _.detailForm.relHistoryList = res.data.data
        _.historyDialogVisible = true
        // _.$store.commit("setCurPhone", _.detailForm.mobile);
      })
    },
    // AXB 598 亲友共享状态映射
    statusText(code) {
      const m = { PENDING: '待确认', SHARING: '共享中', SHARE_FAILED: '共享失败', FRIEND_REJECTED: '亲友已拒绝', OWNER_REMOVED: '桩主已移除', FRIEND_QUIT: '亲友已退出', OWNER_CANCELED: '桩主已取消' }
      return m[code] || code
    },
    // AXB 598 亲友角色映射
    typeText(code) {
      const m = { FAMILY: '家人', FRIEND: '朋友', OTHER: '其他' }
      return m[code] || code
    },
    // AXB 598 亲友权限映射(多选逗号分隔，译为"预约/启停"等)
    permissionText(code) {
      if (!code) return ''
      const m = { RESERVE: '预约', START_STOP: '启停' }
      return code.split(',').map(c => m[c.trim()] || c.trim()).join('、')
    },
  },
  mounted() {
    this.init()
  },
}
</script>
